import { api } from "../client";
import {
  PartialUserQualificationFields,
  UserQualificationFields,
} from "../schema/UserQualification";
import { Config, ConfigMutate } from "../types";

type ApiRequestConfig = Config<UserQualificationFields>;
type ApiRequestConfigMutate = ConfigMutate<PartialUserQualificationFields>;

export const getUserQualifications = async (config?: ApiRequestConfig) => {
  return api.get<UserQualificationFields>("user_user_qualifications", config);
};
export const getUserQualification = (id: number, config?: ApiRequestConfig) => {
  return api.get<UserQualificationFields>(
    `user_user_qualifications/${id}`,
    config
  );
};

export const createUserQualification = (config: ApiRequestConfigMutate) => {
  return api.create<PartialUserQualificationFields, {}>(
    "user_user_qualifications",
    config
  );
};
export const updateUserQualification = (
  id: number,
  config?: ApiRequestConfigMutate
) => {
  return api.update<PartialUserQualificationFields, {}>(
    `user_user_qualifications/${id}`,
    config
  );
};
export const deleteUserQualification = (id: number) => {
  return api.remove<UserQualificationFields>(`user_user_qualifications/${id}`);
};
